import config from '../config';
export var getGateway = function getGateway() {
  if (process.env.REACT_APP_APEX_GATEWAY) {
    return process.env.REACT_APP_APEX_GATEWAY;
  }
  var configGateway = config.global.gateway;
  var currentGateway = localStorage.getItem('tradingServer');
  if (Array.isArray(configGateway)) {
    if (currentGateway && configGateway.includes(currentGateway)) {
      return currentGateway;
    } else {
      /**
       * This means the current gateway was entered via custom box.
       */
      return localStorage.getItem('tradingServer');
    }
  } else {
    if (configGateway && currentGateway !== configGateway) {
      localStorage.setItem('tradingServer', configGateway);
      return configGateway;
    } else {
      return currentGateway;
    }
  }
};
export var getLoginFormGateway = function getLoginFormGateway() {
  if (process.env.REACT_APP_APEX_GATEWAY) {
    return process.env.REACT_APP_APEX_GATEWAY;
  }
  return config.global.gateway;
};